import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { useHistory, useParams } from 'react-router-dom';

import { fetchContact } from 'flow/actions/contact-actions';
import {
    getMobileStatus,
    sendNumberVerification,
} from 'flow/actions/extension-actions';
import Page from 'flow/components/Setting/Page';
import SettingsCalleridSMSEdit from 'flow/components/settings/SettingsCalleridSmsEdit';
import Loading from 'flow/components/ui-components/Loading';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import useContact from 'flow/hooks/useContact';
import useProfiles from 'flow/hooks/useProfiles';
import { routes } from 'flow/types/routes';

import { generatePath } from 'flow/utils/router-utils';
import { ExtensionKey } from 'flow/types/EntityKeys';

const SettingsCalleridSmsEdit = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { openModal } = useModal();

    const { extensionKey, profileKey } = useParams<{
        extensionKey: ExtensionKey;
        profileKey?: string;
    }>();
    const { contact, contactKey } = useContact(extensionKey);
    const { profiles } = useProfiles(extensionKey);

    const smsSenderNameOptions = useAppSelector((state) =>
        state.profiles.get('smsSenderNameOptions'),
    );
    const mobileStatus = useAppSelector((state) =>
        state.extensions.getIn(['extensions', extensionKey, 'mobileStatus']),
    );

    useEffect(() => {
        if (!extensionKey || !contactKey) {
            return;
        }
        dispatch(getMobileStatus(extensionKey));
        dispatch(fetchContact(contactKey));
    }, [extensionKey, contactKey]);

    if (!profiles || !smsSenderNameOptions || !mobileStatus) {
        return <Loading />;
    }

    const handleBack = () => {
        if (profileKey) {
            history.push(
                generatePath(routes['settings.callerid.profile.sms'], {
                    extensionKey,
                }),
            );
        } else {
            history.push(
                generatePath(routes['settings.callerid'], { extensionKey }),
            );
        }
    };

    return (
        <Page header="settings.callerid.sms.title" onClickBack={handleBack}>
            <SettingsCalleridSMSEdit
                handleVerifyNumber={() =>
                    openModal('confirmationDialog', {
                        title: i18next.t('Verify.Dialog.Title'),
                        description: i18next.t('Verify.Dialog.Description'),
                        handleAccept: () =>
                            dispatch(
                                sendNumberVerification(
                                    extensionKey,
                                    contact.get('mobile'),
                                ),
                            ),
                    })
                }
            />
        </Page>
    );
};

export default SettingsCalleridSmsEdit;
